import * as types from './actionTypes';
import handleErrors from './handleErrors';
import getAPIPath from '../../js/modules/api-location';
import { addNotification } from './notificationActions';

export function loadContentSuccess(content) {
  return { type: types.LOAD_CONTENT_SUCCESS, content };
}

export function updateContentSuccess(content) {
  return { type: types.UPDATE_CONTENT_SUCCESS, content };
}

export function createContentSuccess(content) {
  return { type: types.CREATE_CONTENT_SUCCESS, content };
}

export function deleteContentSuccess(contentId) {
  return { type: types.DELETE_FROM_CONTENT_LIST_SUCCESS, contentId };
}

export function loadContent(contentId) {
  return function(dispatch) {
    // If we are loading an individual piece of content (an ID will exist)
    return fetch(`${getAPIPath}queryapi/content?id=${contentId}`, {
      method: `GET`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then(handleErrors)
    .then(response => response.json().then((res) => {
      dispatch(loadContentSuccess(res.data));
    }))
    .catch((error) => {
      throw (error);
    });
  };
}

export function saveContent(content) {
  return function(dispatch) {
    let method;
    if (content.id) {
      // If we are editing a drill (an ID will exist)
      method = `PUT`;
    } else {
      // If we are creating a brand new drill (no ID)
      method = `POST`;
    }

    return fetch(`${getAPIPath}commandapi/content`, {
      method,
      body: JSON.stringify(content),
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
      .then(handleErrors)
      .then(response => response.json().then((res) => {
        window.location.href = res.data.slug;
      }))
      .catch((error) => {
        let message;
        if (error.status && error.status === 401) {
          message = `You do not appear to be logged in. Please log in again to proceed`;
        } else {
          message = `There was a problem saving your practice. Please contact us if the problem persists.`;
        }
        dispatch(addNotification({
          message,
          level: `error`,
          autoDismiss: 0,
        }));
        throw (error);
      });
  };
}

export function deleteContent(contentId, forceDelete) {
  let forceDeleteParams = ``;
  if (forceDelete) {
    forceDeleteParams = `&force_delete=${forceDelete}`;
  }

  return function(dispatch) {
    return fetch(`${getAPIPath}queryapi/content?id=${contentId}${forceDeleteParams}`, {
      method: `DELETE`,
      credentials: `include`,
      headers: {
        Accept: `application/json`,
      },
    })
    .then((response) => {
      if (response.status === 409) {
        throw response;
      } else {
        response.json().then(() => {
          dispatch(deleteContentSuccess(contentId));
          dispatch(addNotification({
            message: `Successfully deleted`,
            level: `success`,
            autoDismiss: 3,
            dismissible: `click`,
          }));
        });
      }
    });
  };
}



// WEBPACK FOOTER //
// ./library/app/actions/contentActions.js